import { Routes } from 'config/routes';
import { PermissionsEnum } from 'gql/types';
import { RouteType } from 'modules/auth/enums';
import { IModule } from 'modules/common/interfaces';
import NotificationsPage from 'modules/notification/page/Notifications';
import ProfilePage from 'modules/user/pages/Profile';

import EmailConfirmationPage from './pages/EmailConfirmation';
import ForgotPasswordPage from './pages/ForgotPassword';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import ResetPassword from './pages/ResetPassword';
import SignUpPage from './pages/SignUp';

const userModule: IModule = {
  routes: [
    {
      path: Routes.SignUp,
      Component: SignUpPage,
      type: RouteType.NoAuth,
    },
    {
      path: Routes.ForgotPassword,
      Component: ForgotPasswordPage,
      type: RouteType.NoAuth,
    },
    {
      path: Routes.ResetPassword,
      Component: ResetPassword,
      type: RouteType.NoAuth,
    },
    {
      path: Routes.EmailConfirmation,
      Component: EmailConfirmationPage,
      type: RouteType.Public,
    },
    {
      path: Routes.Profile,
      Component: ProfilePage,
      type: RouteType.Auth,
    },
    {
      path: Routes.UserNotifications,
      Component: NotificationsPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ReceiveNotifications],
    },
    {
      path: Routes.PrivacyPolicy,
      Component: PrivacyPolicyPage,
      type: RouteType.Public,
    },
  ],
};

export default userModule;
